import { Component, EventEmitter, Input, Output } from '@angular/core';
import { AccountRow } from 'src/app/utils/account-menu';

/** Card de filas de cuenta (sheet de cuenta y Mi cuenta). Solo pinta y avisa qué fila se tocó. */
@Component({
  selector: 'app-account-menu-card',
  templateUrl: './account-menu-card.component.html',
  styleUrls: ['./account-menu-card.component.scss'],
  standalone: false,
})
export class AccountMenuCardComponent {
  @Input({ required: true }) rows!: readonly AccountRow[];
  @Output() rowSelected = new EventEmitter<AccountRow>();
}
